import { useMemo } from "react"

const Iframe = ({ title, content }) => {
  const writeHTML = useMemo(
    () => (frame) => {
      if (!frame) {
        return
      }
      const doc = frame.contentDocument
      doc.open()
      doc.write(content)
      doc.close()
      frame.style.width = "100%"
      frame.style.height = 0
      frame.style.height = `${frame.contentWindow.document.body.scrollHeight}px`
      frame.sandbox = ""

      const links = doc.getElementsByTagName("a")
      for (let i = 0; i < links.length; i++) {
        links[i].setAttribute("target", "_blank")
        links[i].setAttribute("rel", "noopener")
      }
    },
    [content]
  )
  return (
    <iframe
      title={title}
      src="about:blank"
      scrolling="no"
      frameBorder="0"
      ref={writeHTML}
    />
  )
}
export default Iframe
